<form [formGroup]="stockNumForm" class="form-inline">
  <div class="form-group pr-1 mb-0">
    <input class="form-control" formControlName="stockNum" type="text" [maxlength]="REQS.maxLength.standard" placeholder="Stock Number" required/>
  </div>
  <button class="btn app-btn-secondary" (click)="onSubmit(stockNumForm.value)">
    Northstar
  </button>
</form>
